import React from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from '@stores/usersSlice';
import { selectFullScreen } from '@stores/fullScreenSlice';
import { checkForFullScreen } from '@awp/helpers/navigation';
import { Container, Nav, Navbar } from 'react-bootstrap';

const Footer = ({ isBarExpanded = false }) => {
  const currentUser = useSelector(selectCurrentUser);
  const fullScreen = useSelector(selectFullScreen);

  if (checkForFullScreen(fullScreen.enabled)) return <></>;

  return (
    <>
      <footer className="footer mt-4">
        <Navbar variant="light" bg="light" expand={false} className={isBarExpanded ? 'd-none d-md-block' : 'fa-xs p-4'}>
          <Container className="align-items-start">
            <Navbar.Brand href="#home" className="mr-auto mb-5">
              <img
                className="img-fluid"
                src="/assets/images/bcid-logo-en.svg"
                width="150"
                height="39.67"
                alt="B.C. Government Logo"
              />
            </Navbar.Brand>
            <div className="d-flex justify-content-between flex-wrap">
              <Nav as="ul" className="mr-5">
                <Nav.Item as="li">
                  <strong>MORE INFO</strong>
                </Nav.Item>
                <Nav.Item as="li">
                  <Nav.Link
                    href="https://www2.gov.bc.ca/gov/content?id=79F93E018712422FBC8E674A67A70535"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Disclaimer
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item as="li">
                  <Nav.Link
                    href="https://www2.gov.bc.ca/gov/content?id=9E890E16955E4FF4BF3B0E07B4722932"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item as="li">
                  <Nav.Link
                    href="https://www2.gov.bc.ca/gov/content?id=E08E79740F9C41B9B0C484685CC5E412"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Accessibility
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item as="li">
                  <Nav.Link
                    href="https://www2.gov.bc.ca/gov/content?id=1AAACC9C65754E4D89A118B875E0FBDA"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Copyright
                  </Nav.Link>
                </Nav.Item>
              </Nav>
              <Nav as="ul" className="mr-5">
                <Nav.Item as="li">&nbsp;</Nav.Item>
                <Nav.Item as="li">
                  <Nav.Link
                    href="https://www2.gov.bc.ca/gov/content?id=6A77C17D0CCB48F897F8598CCC019111"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Contact Us
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </div>
            <hr style={{ width: '100%', borderColor: '#353433' }} />
            <Navbar.Text className="mr-2">© 2024 Government of British Columbia</Navbar.Text>
            <Navbar.Text>Version {currentUser.Version}</Navbar.Text>
          </Container>
        </Navbar>
      </footer>
    </>
  );
};

export default Footer;
